export default __webpack_public_path__ + "static/media/friendsManagerImage3.465e0d5b.png";